import { StyleSheet } from 'react-native';
import { BLACK_700, tokens } from '@airtel/air-design-system';
export var getServiceSelectionStepWidgetStyles = () => {
  var _tokens$spacing = tokens.spacing,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_16 = _tokens$spacing.SPACING_16,
    SPACING_20 = _tokens$spacing.SPACING_20,
    SPACING_12 = _tokens$spacing.SPACING_12;
  return StyleSheet.create({
    titleComponent: {
      width: '100%'
    },
    content: {
      paddingTop: SPACING_8,
      paddingHorizontal: SPACING_16,
      paddingBottom: SPACING_16
    },
    mainRadioContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end'
    },
    subRadioContainer: {
      flexDirection: 'column',
      alignItems: 'stretch',
      flexWrap: 'nowrap'
    },
    subRadioTitle: {
      marginBottom: SPACING_12,
      color: BLACK_700
    },
    subContainer: {
      marginTop: SPACING_20
    },
    radio: {
      marginTop: SPACING_20
    }
  });
};